/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiEntityGroupScreeningConfiguration,
    InternalApiEntityGroupScreeningConfigurationFromJSON,
    InternalApiEntityGroupScreeningConfigurationToJSON,
} from '../models';

export interface UpdateExcludedFromDailyScreeningRequest {
    internalApiEntityGroupScreeningConfiguration: Array<InternalApiEntityGroupScreeningConfiguration>;
}

/**
 * 
 */
export class EntityGroupScreeningConfigurationApi extends runtime.BaseAPI {

    /**
     * Fetches entity group screening configurations
     */
    async findConfigurationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiEntityGroupScreeningConfiguration>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-configuration/entity-groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiEntityGroupScreeningConfigurationFromJSON));
    }

    /**
     * Fetches entity group screening configurations
     */
    async findConfigurations(initOverrides?: RequestInit): Promise<Array<InternalApiEntityGroupScreeningConfiguration>> {
        const response = await this.findConfigurationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates entity group excluded from screening configurations
     */
    async updateExcludedFromDailyScreeningRaw(requestParameters: UpdateExcludedFromDailyScreeningRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiEntityGroupScreeningConfiguration>>> {
        if (requestParameters.internalApiEntityGroupScreeningConfiguration === null || requestParameters.internalApiEntityGroupScreeningConfiguration === undefined) {
            throw new runtime.RequiredError('internalApiEntityGroupScreeningConfiguration','Required parameter requestParameters.internalApiEntityGroupScreeningConfiguration was null or undefined when calling updateExcludedFromDailyScreening.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-configuration/entity-groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.internalApiEntityGroupScreeningConfiguration.map(InternalApiEntityGroupScreeningConfigurationToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiEntityGroupScreeningConfigurationFromJSON));
    }

    /**
     * Updates entity group excluded from screening configurations
     */
    async updateExcludedFromDailyScreening(requestParameters: UpdateExcludedFromDailyScreeningRequest, initOverrides?: RequestInit): Promise<Array<InternalApiEntityGroupScreeningConfiguration>> {
        const response = await this.updateExcludedFromDailyScreeningRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
